export const createTableSelector = (selectOwnState, tableName) => (state) => {
    return selectOwnState(state)[tableName]
}



// WEBPACK FOOTER //
// ./src/modules/table/state/selector.js